import { useState, createContext, useContext, type Dispatch, type SetStateAction } from 'react'
import { noop } from 'lodash-es'
import type { BillingCouponType, BillingPromotionCodeType } from 'gql/types'

export interface PromoCodeDetails {
  applied: boolean
  code?: BillingPromotionCodeType['code']
  id: BillingPromotionCodeType['id']
  termsLink: BillingCouponType['termsLink']
  description: BillingCouponType['description']
  displayName: BillingCouponType['displayName']
  amountOff?: Pick<NonNullable<BillingCouponType['amountOff']>, 'formattedNoCents'> | null
}

export interface AppliedPromoCodeContext {
  promoCode: PromoCodeDetails | null
  setPromoCode: Dispatch<SetStateAction<AppliedPromoCodeContext['promoCode']>>
}

const AppliedPromoCodeContext = createContext<AppliedPromoCodeContext>({
  promoCode: null,
  setPromoCode: noop,
})

interface AppliedPromoCodeProviderProps {
  promoCode?: PromoCodeDetails | null
}

export const AppliedPromoCodeProvider: Settle.FC<AppliedPromoCodeProviderProps> = ({ children, ...props }) => {
  const [promoCode, setPromoCode] = useState<AppliedPromoCodeContext['promoCode']>(props.promoCode ?? null)

  return (
    <AppliedPromoCodeContext.Provider
      value={{
        promoCode,
        setPromoCode,
      }}
    >
      {children}
    </AppliedPromoCodeContext.Provider>
  )
}

export const useAppliedPromoCodeContext = () => useContext(AppliedPromoCodeContext)
